
<mat-form-field class="full-width">

  <mat-label ssFormLabel></mat-label>
  <ss-autocomplete-control></ss-autocomplete-control>
  <mat-error ssFormValidationMessage></mat-error>
  <mat-spinner matSuffix *ngIf="(fetchingSubject | async)" diameter="24" class="spinner"></mat-spinner>
  <mat-hint>{{hintObs | async}}</mat-hint>
  <ng-content></ng-content>

</mat-form-field>
